var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Big_Icons",
    "data-name": "Big Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eCommerce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_1",
    "data-name": "Rounded Rectangle 1",
    className: "cls-1",
    d: "M13.153,11.123H37.847A2.86,2.86,0,0,1,40.7,13.994l2.849,29.669A2.86,2.86,0,0,1,40.7,46.534H10.3a2.86,2.86,0,0,1-2.849-2.871L10.3,13.994A2.86,2.86,0,0,1,13.153,11.123Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.391,
    cy: 19.25,
    r: 2.484
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_copy",
    "data-name": "Ellipse 1 copy",
    className: "cls-1",
    d: "M31.6,16.845a2.414,2.414,0,1,1-2.479,2.413A2.447,2.447,0,0,1,31.6,16.845Zm-3.725-6.722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_2",
    "data-name": "Rounded Rectangle 2",
    className: "cls-1",
    d: "M18.852,16.865V6.337A2.86,2.86,0,0,1,21.7,3.466h7.6a2.86,2.86,0,0,1,2.849,2.871V16.865"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.505,44.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.3,36.006l31.341-4.785,0.95,13.4L8.4,45.577Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.0eb9539b503ac076ac2ec5cf02af7918.svg";
export { ForwardRef as ReactComponent };